import React from 'react';
import ExpandablePanel from './expandable-panel';

const SupportPlaceFilters = ({
  isMobile,
  label,
  list,
  showAllFiltersButtonText,
  onFilterChange,
  selectedFilters,
  resetFilters,
}) => {
  const handleKeyDown = (event, filter) => {
    if (event.key === ' ' || event.key === 'Enter') {
      event.preventDefault();
      if (filter.showAllButton) {
        resetFilters();
      } else {
        onFilterChange(filter);
      }
    }
  };

  const FilterList = () => {
    return (
      <ul
        aria-labelledby="support-place-filter-label"
        className="c-support-place__filter-list"
      >
        {[
          {
            Name: showAllFiltersButtonText || 'Ingen filtrering',
            Id: -1,
            showAllButton: true,
          },
          ...list,
        ]?.map(({ Name, Id, showAllButton, ImagePath }) => (
          <li key={Id} className="c-support-place__filter-item">
            <input
              tabIndex={-1}
              type="checkbox"
              id={`support-place-filter-${Id}`}
              name="supportPlaceFilters"
              value={Name}
              className="c-support-place__filter-input"
              checked={
                selectedFilters.some((filter) => filter.Id === Id) ||
                (showAllButton && selectedFilters.length === 0)
              }
              onChange={() =>
                showAllButton ? resetFilters() : onFilterChange({ Name, Id })
              }
            />
            <label
              tabIndex={0}
              onKeyDown={(event) =>
                handleKeyDown(event, { Name, Id, showAllButton })
              }
              htmlFor={`support-place-filter-${Id}`}
              className="c-support-place__filter-button"
            >
              {!showAllButton && (
                <img
                  className="c-support-place__filter-img"
                  src={ImagePath}
                  alt=""
                  aria-hidden
                />
              )}
              <span data-text={Name}>{Name}</span>
            </label>
          </li>
        ))}
      </ul>
    );
  };

  return (
    <>
      {isMobile ? (
        <ExpandablePanel label={label}>
          <FilterList />
        </ExpandablePanel>
      ) : (
        <>
          <label
            id="support-place-filter-label"
            className="c-support-place__label"
          >
            {label}
          </label>
          <FilterList />
        </>
      )}
    </>
  );
};

export default SupportPlaceFilters;
